import { useTrans } from "@/translations";

import { useMemo } from "react";

import type { WasteAmountsPoint, WasteAmountsStream } from "../types";

type Props = {
  active?: boolean;
  payload?: {
    payload?: WasteAmountsPoint;
  }[];
  label?: string;
  streams: WasteAmountsStream[];
};

export const WasteTooltip: React.FC<Props> = ({
  active,
  payload,
  label,
  streams,
}) => {
  const { t } = useTrans();

  const reversedStreams = useMemo(() => [...streams].reverse(), [streams]);

  if (!active || !payload?.length) {
    return null;
  }

  const point: WasteAmountsPoint | undefined = payload[0]?.payload;
  if (!point) {
    return null;
  }

  return (
    <div className="rounded-lg bg-black px-[9.9px] py-1.5 text-[12px] text-white shadow-lg">
      <div className="mb-[4.95px] font-semibold">{label}</div>
      {reversedStreams
        .filter((s) => Number(point[s.key]) > 0)
        .map((s) => (
          <div
            key={s.key}
            className="mt-[1.65px] flex items-center justify-between gap-[11.55px]"
          >
            <span className="flex items-center gap-[4.95px]">
              <span
                className="inline-block h-1.5 w-1.5 flex-none rounded-sm border border-white/30"
                style={{ background: s.color }}
              />
              {s.name}
            </span>
            <span className="pl-1.5 font-semibold whitespace-nowrap">
              {Number(point[s.key]).toLocaleString()} kg
            </span>
          </div>
        ))}
      <div className="mt-[4.95px] flex items-center justify-between gap-[11.55px] border-t border-white/20 pt-[4.95px]">
        <span className="opacity-80">
          {t("homePage:wasteAmountsTooltipTotal")}
        </span>
        <span className="font-semibold">{point.total.toLocaleString()} kg</span>
      </div>
    </div>
  );
};
